











































































































































































import { Component, Watch } from 'vue-property-decorator';
import axios from 'axios';
import * as StringUtil from '@/common/StringUtil';
import MarkdownToHTML from '@/common/MarkdownToHTML';
import RepositoryFactory from '@/repository/RepositoryFactory';
import BaseView from '@/views/BaseView.vue';
import Question from '@/models/entry/Question';
import QuestionResources from '@/models/entry/QuestionResources';
import Answer from '@/models/entry/Answer';
import AnswerDetails from '@/models/entry/AnswersDetails';
import PutSingleAnswer from '@/models/entry/PutSingleAnswer';
import PutAllQuestionAnswer from '@/models/entry/PutAllQuestionAnswer';
import PutAllQuestionAnswerDetail from '@/models/entry/PutAllQuestionAnswerDetail';

import ExamRadio from '@/components/ExamRadio.vue';
import ExamCheckBox from '@/components/ExamCheckBox.vue';
import ExamSelect from '@/components/ExamSelect.vue';
import ExamTimer from '@/components/ExamTimer.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';
import * as DesignCode from '@/classification/DesignCode';

/**
 * リソースダウンロード情報まとめ
 */
interface DownloadInfo {
  uri: string;
  question: Question;
  resource: QuestionResources;
}

/**
 * video、audioのロード
 */
interface ControlsFunction {
  load: () => void;
}

@Component({
  components: {
    'e-radio': ExamRadio,
    'e-checkBox': ExamCheckBox,
    'e-select': ExamSelect,
    'e-timer': ExamTimer,
    'e-indicator': IndicatorModal,
  },
})
export default class GuestExam extends BaseView {
  /**
   * コピーライト
   */
  copyright = '';

  /**
   * 受験申込コード
   */
  entryCode = '';

  /**
   * 検定ランクコード
   */
  rankCode = '';

  /**
   * 解答結果コード
   */
  resultCode = '';

  /**
   * 制限時間
   */
  timerSec = 0;

  /**
   * 通知時間
   */
  notificationSec = 0;

  /**
   * 問題情報格納用
   */
  questions: Question[] = [];

  /**
   * 現在表示中の問題格納用
   */
  current = new Question();

  /**
   * 試験開始準備完了フラグ
   */
  isReady = false;

  /**
   * 試験開始フラグ
   */
  isExamStart = false;

  /**
   * タイマー起動フラグ
   */
  isTimerStart = false;

  /**
   * 試験終了確認モーダル表示フラグ
   */
  isEndConfirm = false;

  /**
   * インジケーターフラグ
   */
  isIndicatorDisplay = false;

  progressPercent = 0;

  /**
   * 解答データ、リソースデータのダウンロード総数保存用
   */
  totalDownloadDataCount = 0;

  /**
   * 現在ダウンロード完了している個数カウント
   */
  nowLoadingCount = 0;

  GuestEntryRepo = RepositoryFactory.get().guest;

  retryMsg = 'に失敗しました。\n再実行しますか？\n※何度も発生する場合はお問合せページよりご連絡ください。';

  @Watch('current')
  contentsReload() {
    if (this.getVideoInfo()) {
      this.$nextTick(() => {
        const videoTag = document.getElementById('video') as HTMLElement & ControlsFunction;
        if (videoTag) {
          videoTag.load();
        }
      });
    }

    if (this.getAudioInfo()) {
      this.$nextTick(() => {
        const audioTag = document.getElementById('audio') as HTMLElement & ControlsFunction;
        if (audioTag) {
          audioTag.load();
        }
      });
    }
  }

  async mounted() {
    document.addEventListener('contextmenu', () => false);

    await this.getCopyright();

    // 親ウィンドウが無い、親ウィンドウがアカウント不要の試験前ページ or 試験結果ページ以外だった場合TOPへ
    const { opener } = window;
    if (!opener || (opener.location.pathname !== this.paths.EXAM_READY && opener.location.pathname !== this.paths.GUEST_EXAM_RESULT)) {
      this.$router.replace(this.paths.TOP);
      return;
    }

    window.opener = null;

    // 受験申込コード or ランクコードがない場合強制敵にTOPへ飛ばす
    if (!this.$route.query.entry || !this.$route.query.rank) {
      this.$router.replace(this.paths.TOP);
      return;
    }

    this.entryCode = this.$route.query.entry as string;
    this.rankCode = this.$route.query.rank as string;

    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const ExamIndexCss = document.createElement('link');
    ExamIndexCss.rel = 'stylesheet';
    ExamIndexCss.href = '/exam/css/index.css';
    this.$el.appendChild(ExamIndexCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);

    const ExamIndexJs = document.createElement('script');
    ExamIndexJs.src = '/exam/js/index.js';
    this.$el.appendChild(ExamIndexJs);

    try {
      // 検定問題検索
      await this.getQuestions();

      // 解答情報取得
      await this.getAnswers();

      // リソース取得
      await this.resourceDownLoad();

      // 問題配列1番目を初期表示
      const [firstData] = this.questions;
      this.current = firstData;

      // 試験開始準備完了
      this.isReady = true;
    } catch (e) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /* eslint-disable class-methods-use-this */
  beforeDestroy() {
    document.addEventListener('contextmenu', () => true);
  }

  /**
   * 問題取得
   */
  async getQuestions() {
    let rejected = false;
    await this.GuestEntryRepo.getGuestQuestion(this.entryCode)
      .then((response) => {
        this.questions = this.GuestEntryRepo.convert.deserializeArray(response.data.questions, Question);
        this.resultCode = response.data.examination_result_code;

        if (this.questions.length > 0) {
          this.questions.forEach((q, index) => {
            const question = q;
            // 出題順番号付与
            question.questionNumber = index + 1;
            // 問題文のMarkdownパース
            question.questionStatement = MarkdownToHTML(question.questionStatement);
            question.subQuestions.forEach((subQuestion) => {
              const subQ = subQuestion;
              // 設問タイトルのMarkdownパース
              subQ.subQuestionTitle = MarkdownToHTML(subQ.subQuestionTitle);
              // 取得された設問情報を解答情報にセット
              subQ.answer.questionCode = subQ.questionCode;
              subQ.answer.version = subQ.version;
              subQ.answer.order = subQ.order;
              subQ.choices.forEach((choice) => {
                // 設問選択肢のMarkdownパース
                const c = choice;
                c.choiceTitle = MarkdownToHTML(c.choiceTitle);
              });
            });
          });
        } else {
          rejected = true;
        }
      }).catch(() => {
        rejected = true;
      });

    // エラー時の再実行確認
    if (rejected) {
      // eslint-disable-next-line no-alert
      if (window.confirm(`問題の取得${this.retryMsg}`)) {
        await this.getQuestions();
      } else {
        this.$router.replace(this.paths.TOP);
      }
    }
  }

  /**
   * 解答済みデータ取得
   */
  async getAnswers() {
    let rejected = false;
    await this.GuestEntryRepo.getGuestAnswer(this.entryCode, this.resultCode)
      .then((response) => {
        const answerDetail = this.GuestEntryRepo.convert.deserializeArray(response.data.details, AnswerDetails);
        // 解答保持オブジェクトを作成
        answerDetail.forEach((detail) => {
          // 問題コードで紐づけ
          const question = this.questions.find((q) => q.questionCode === detail.questionCode) as Question;
          question.isBookMark = detail.bookmark;

          // 設問を探索
          question.subQuestions.forEach((sq) => {
            const subQ = sq;
            const answer = detail.answers
              .find((ans) => ans.version === subQ.version && ans.order === subQ.order);
            if (!answer) return;
            // 設問バージョン、表示順が合致する解答を適用
            subQ.answer = answer;
          });
        });
      })
      .catch(() => {
        rejected = false;
      });

    // エラー時の再実行確認
    if (rejected) {
      // eslint-disable-next-line no-alert
      if (window.confirm(`問題の取得${this.retryMsg}`)) {
        await this.getAnswers();
      } else {
        this.$router.replace(this.paths.TOP);
      }
    }
  }

  /**
   * コピーライト文言取得
   */
  async getCopyright() {
    const ExamRepository = RepositoryFactory.get().exam;
    ExamRepository.getExamDesignResource(DesignCode.COPY_RIGHT).then((response) => {
      if (response.status === 200 && response.data !== undefined) {
        this.copyright = response.data.display_text;
      }
    });
  }

  /**
   * 問題リソースダウンロード
   */
  async resourceDownLoad() {
    // 取得失敗時の情報保持用配列
    const downloadInfo: DownloadInfo[] = [];
    this.questions.forEach((questionValue, index) => {
      const question = questionValue;
      question.questionNumber = index + 1;
      question.questionResources.forEach((resourceData) => {
        this.totalDownloadDataCount += 1;
        const resource = resourceData;
        const uri = `${process.env.VUE_APP_DESIGN_RESOURCE_BASE}${resource.resourceUri}`;
        downloadInfo.push({ uri, question, resource });
      });
    });
    this.totalDownloadDataCount = downloadInfo.length;
    // ダウンロード実行
    await this.execDownload(downloadInfo);
  }

  /**
   * ダウンロード実行処理（再帰呼び出し対応）
   */
  async execDownload(downloadInfo: DownloadInfo[]) {
    const rejectInfo: DownloadInfo[] = [];
    const results: Promise<any>[] = [];

    // ダウンロード処理生成
    downloadInfo.forEach((info) => {
      results.push(this.createDownLoadPromice(info).catch(() => {
        rejectInfo.push(info);
      }));
    });

    // 一括実行
    await Promise.all(results);

    // エラー時の再実行確認
    if (rejectInfo.length !== 0) {
      // eslint-disable-next-line no-alert
      if (window.confirm(`問題の取得${this.retryMsg}`)) {
        this.execDownload(rejectInfo);
      } else {
        this.$router.replace(this.paths.TOP);
      }
    }
  }

  /**
   * リソースダウンロード処理Promise生成
   */
  createDownLoadPromice(downloadInfo: DownloadInfo) {
    const { uri, question, resource } = downloadInfo;
    // arraybuffer オプション必須
    return axios.get(uri, { responseType: 'arraybuffer' })
      .then((response) => {
        const contentType = response.headers['content-type'].split(';')[0];
        const blob = new Blob([response.data], { type: contentType });
        const srcUrl = URL.createObjectURL(blob);
        // ダウンロードされたファイルの実体を保持
        resource.contents = blob;
        resource.contentType = contentType;
        resource.localSrcUri = srcUrl;

        // 画像の場合、各所の対応する独自タグを置換
        if (contentType.indexOf('image') !== -1) {
          const replaceTag = `{{${resource.resourceFileName}}}`;
          const imgTagString = `<img src="${srcUrl}" alt="${resource.alternativeText}" />`;
          // 問題本文
          question.questionStatement = question.questionStatement.replace(replaceTag, imgTagString);

          const { subQuestions } = question;
          subQuestions.forEach((subQ) => {
            const targetSubq = subQ;
            // 設問タイトル
            targetSubq.subQuestionTitle = targetSubq.subQuestionTitle.replace(replaceTag, imgTagString);
            targetSubq.choices.forEach((choice) => {
              const targetChoice = choice;
              // 問題選択肢
              targetChoice.choiceTitle = targetChoice.choiceTitle.replace(replaceTag, imgTagString);
            });
          });
        }

        // プログレスバー計算
        this.nowLoadingCount += 1;
        this.progressPercent = Math.round((this.nowLoadingCount / this.totalDownloadDataCount) * 100);
      });
  }

  /**
   * 試験開始
   */
  async examStart() {
    this.isIndicatorDisplay = true;
    try {
      await this.GuestEntryRepo.postGuestExamStart(this.entryCode, this.resultCode)
        .then((response) => {
          this.timerSec = response.data.time_sec as number;
          this.notificationSec = response.data.notification_limit_sec as number;
          this.isExamStart = true;
          this.isTimerStart = true;
        });
    } catch {
      // eslint-disable-next-line no-alert
      if (window.confirm(`試験開始処理${this.retryMsg}`)) {
        await this.examStart();
      } else {
        this.$router.replace(this.paths.TOP);
      }
    } finally {
      this.isIndicatorDisplay = false;
    }
  }

  /**
   * 単体での解答保存
   */
  saveAnswer() {
    const putAnswer = new PutSingleAnswer();
    putAnswer.bookmark = this.current.isBookMark;
    this.current.subQuestions.forEach((subQ) => {
      putAnswer.answers.push(subQ.answer);
    });
    const questionCode = StringUtil.encodeToBase64Url(this.current.questionCode);
    this.GuestEntryRepo.putGuestAnswer(this.entryCode, this.resultCode, questionCode, putAnswer)
      .catch((err) => {
        // 失敗しても試験を続行する
        console.log(err);
      });
  }

  /**
   * 解答終了
   */
  async examEnd() {
    this.isIndicatorDisplay = true;
    const allAnswers: PutAllQuestionAnswer[] = [];
    // すべての問題から解答情報を取り出す
    this.questions.forEach((question) => {
      // 全解答送信用クラスを作成
      const allAnswer = new PutAllQuestionAnswer();
      allAnswer.questionCode = question.questionCode;
      // 各設問の解答情報を取得
      question.subQuestions.forEach((subQ) => {
        const detail = new PutAllQuestionAnswerDetail();
        const { answer } = subQ;
        detail.version = answer.version;
        detail.order = answer.order;
        detail.choiceCodes = answer.choiceCodes;
        detail.answer = answer.answer;
        allAnswer.answers.push(detail);
      });
      allAnswers.push(allAnswer);
    });

    try {
      await this.GuestEntryRepo.putGuestExamEnd(this.entryCode, this.resultCode, allAnswers)
        .then(() => {
          this.$router.replace(`${this.paths.GUEST_EXAM_FINISH}?rank=${this.rankCode}&entry=${this.entryCode}&result=${this.resultCode}`);
        });
    } catch (e) {
      // eslint-disable-next-line no-alert
      if (window.confirm(`解答情報の送信${this.retryMsg}`)) {
        await this.examEnd();
      } else {
        this.$router.replace(this.paths.TOP);
      }
    } finally {
      this.isIndicatorDisplay = false;
    }
  }

  /**
   * 後で見直す押下での保存中か
   */
  isBookmarkSave = false;

  /**
   * 後で見直す押下時の
   */
  bookMark() {
    this.current.isBookMark = !this.current.isBookMark;
    try {
      this.saveAnswer();
    } catch (e) {
      // 失敗しても試験を続行する
      console.log(e);
    }
  }

  /**
   * 次へ/前へ
   */
  moveCurrent(vector: number) {
    const nextIndex = this.current.questionNumber - 1 + vector;
    const next = this.questions[nextIndex];

    if (next) {
      this.setCurrent(next);
    }
  }

  /**
   * 選択中問題のセット
   */
  setCurrent(question: Question) {
    try {
      this.saveAnswer();
    } catch (e) {
      // 失敗しても処理を続行する
      console.log(e);
    }
    this.current = question;
  }

  /**
   * content-type に該当するリソースURIとコンテンツタイプを返す
   */
  getResourceInfo(type: string) {
    const resource = this.current.questionResources.find((value) => {
      if (!StringUtil.isEmpty(value.contentType)) {
        const contentsType = value.contentType;
        if (contentsType.indexOf(type) !== -1) return true;
      }
      return false;
    });

    if (resource) {
      const { localSrcUri, contentType } = resource;
      return { localSrcUri, contentType };
    }
    return null;
  }

  /**
   * 動画リソース情報取得
   */
  getVideoInfo() {
    return this.getResourceInfo('video');
  }

  /**
   * 音声リソース情報取得
   */
  getAudioInfo() {
    return this.getResourceInfo('audio');
  }

  /**
   * ロード中プログレスバーstyle
   */
  get progress() {
    return { width: `${this.progressPercent}%` };
  }

  /**
   * 全問題に回答したか否か
   */
  get answeredAllQuestions(): boolean {
    return this.questions.every((question) => question.isAnswer());
  }
}
